import { type RouteObject } from "react-router-dom";

import { SignIn } from "./SignIn";

export const AuthRoutes: RouteObject[] = [
  {
    path: "/",
    element: <SignIn />,
  },
];
